import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value || value.length !== 10) {
    return { incompleteDate: true };
  }

  const [day, month, year] = value.split('/').map(Number);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return { invalidDate: true };
  }

  const date = new Date(year, month - 1, day);

  const isValidDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

  if (!isValidDate) {
    return { invalidDate: true };
  }

  return null;
}
